import { RolesSharedService } from "./../../services/roles-shared.service";
import { Component, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import swal from "sweetalert2";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { debounceTime , distinctUntilChanged, switchMap, map, filter} from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { Subscription } from "rxjs";
import { LoaderService } from "@app/shared/services/loader.service";
@Component({
  selector: "app-analyst-list",
  templateUrl: "./analyst-list.component.html",
  styleUrls: ["./analyst-list.component.css"]
})
export class AnalystListComponent implements OnInit {
  @ViewChild('searchInput') searchInput : ElementRef;
  filterObj: any = {}
  userDetailsObject: object;
  analystData = [];
  viewProfileDrop;
  userRole: string;
  loggedInStatus;

  searchString = "";
  sortSelectedindex = null;
  noResearchData: boolean;

  userId: string;
  // Filter
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;
  url: string;
  subscription: Subscription;

  constructor(
    public rolesSharedService: RolesSharedService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private breadcrumService: BreadcrumService,
    @Inject(DOCUMENT) private document: Document,
    private loaderService: LoaderService

  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);
  }

  ngOnInit() {
    this.userDetails();
    // this.analystDataObj();
    this.getAnalystList();
    this.isLoggedIn();
    this.clearBredcumLabels();
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // if character length greater then 2
      // ,filter(res => res.length > 2)
      // Time in milliseconds between key events
      ,debounceTime(1000)        
      // If previous query is diffent from current   
      ,distinctUntilChanged()
      // subscription for response
      ).subscribe((text: string) => {
        this.searchString = text;
        this.analystData = [];
        this.dataLimit = 9;
        this.skipValue = 0;
        this.getAnalystList();
      });
  }

  // temp fix need to change next release
  clearBredcumLabels() {
    const BC2Label = sessionStorage.getItem('BC2Label');
    const BC3Url = sessionStorage.getItem('BC3Url');
    if(BC2Label){
      sessionStorage.removeItem('BC2Label');
    }
    if(BC3Url){
      sessionStorage.removeItem('BC3Url');
    }
   }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).userId;

    }
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getAnalystListFilter() {
    const filter: any = {};
    filter.search = this.searchString;
    // filter.filter = JSON.stringify({
    //   where: {
    //     and: [
    //       {
    //         "name": {
    //           "ilike": `%${this.searchString}%`
    //         }
    //       },
    //       {
    //         code: "tech_analyst"
    //       }
    //     ]
    //   },
    //   include: [{
    //     relation: "followers"
    //   }, "ratings"]
    // });
    // filter.limit = this.dataLimit;
    // filter.skip = this.skipValue;
    // if (this.sortSelectedindex) {
    //   filter.sort = JSON.stringify({
    //     popularity: this.sortSelectedindex
    //   });
    // }
    // if (this.techDomainListselected) {
    //   filter.where = JSON.stringify({
    //     techDomainId: this.techDomainListselected
    //   });

    return filter;
  }
  onScrollDown() {
    this.skipValue = this.skipValue + 9;
    this.getAnalystList();
  }
  getAnalystList() {
    let searchKey = this.searchString;
    this.rolesSharedService.getAnalystListDetails(this.getAnalystListFilter()).subscribe((data: any) => {
      if (searchKey === this.searchString) {
      this.analystData = data;
      this.loaderService.display(false);
      }
    });
  }
  applyFilter() {
    this.analystData = [];
    this.dataLimit = 9;
    this.skipValue = 0;
    this.getAnalystList();
  }

  changeStyle($event, data, index) {
    data.drop = $event.type == "mouseover" ? true : false;
  }

  followAnalyst(AnalystData, index) {
    if (this.loggedInStatus) {
      const filter: any = {}
      filter.filter = JSON.stringify({
        analystUserId: AnalystData.id,
        followerUserId: this.userId
      })

      this.rolesSharedService.analystFollow(filter.filter).subscribe(
        followResponse => {

          if (followResponse["followed"]) {
            // case when user is liked and updated in server
            AnalystData.isFollow = true;
            AnalystData.followerCount += 1;
          } else if (!followResponse["followed"]) {
            // case when user is not liked and updated in server
            AnalystData.isFollow = false;
            AnalystData.followerCount -= 1;
          }
        });
    }
    else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  featureUnderConstructionNavigation() {
    if (this.loggedInStatus) {
      this.router.navigate([`${this.userRole}/under-construction`]);
    } else {
      this.router.navigate([`under-construction`]);
    }
  }

  routeTechAnalystProfilePage(analystId: string, name: string) {
    this.breadcrumService.setUrl('BC3Label', name);

    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } });
  }
  schdeuleCall(analystId) {
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/analyst-list/analyst-list.component.ts